import { Button, Checkbox } from '@blueprintjs/core';
import React, { useState } from 'react';
import { Page } from '../../utils/Layout/Layout';
import { useAppContext } from '../AppContext';

export default function Settings() {
  const { state, dispatch, dispatchAction } = useAppContext();

  const { user } = state;
  return (
    <Page>
      <h1> Settings</h1>

      <p> User</p>
      <pre>{JSON.stringify(user, null, 2)}</pre>

      <Button
        onClick={() => dispatch({ type: 'ERROR', payload: Error('Fake') })}
      >
        Test Error
      </Button>
    </Page>
  );
}
